import { GroupByMode, newTaskSuffix } from '@griply/types';
import {
  createDefaultSchedule,
  getHiddenLinkedItemLabels,
  getNewTaskPrefill,
} from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';

import { TreeTaskCard } from '../tree-task-card';
import { TypeHeader } from '../type-header';
import { useTypeRenderData } from './type-render-context';

export const TypeRenderItem: React.FC<RenderItemProps> = ({
  item,
  itemInstance,
  tree,
  isMultiSelectModifierPressed,
}) => {
  const {
    groupSettings,
    tasksMap,
    tasks,
    today,
    defaultNewTaskDate,
    denseFormat,
  } = useTypeRenderData();

  const type = item.type;

  if (type === TaskListItemTypes.Task) {
    const task = tasksMap[item.sourceId];
    if (!task) {
      return null;
    }
    const { hideGoal, hideLifeArea } = getHiddenLinkedItemLabels(
      task,
      groupSettings,
    );
    return (
      <TreeTaskCard
        task={task}
        tree={tree}
        item={itemInstance}
        tasks={tasks}
        isMultiSelectModifierPressed={isMultiSelectModifierPressed}
        displayDue={groupSettings.displayDue}
        hideGoal={hideGoal}
        hideLifeArea={hideLifeArea}
      />
    );
  }

  if (type === TaskListItemTypes.NewTask) {
    const groupSectionId = item.sourceId.replace(newTaskSuffix, '');
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.Type,
      groupSectionId,
      groupSetting: groupSettings,
      today,
      defaultNewTaskDate,
    });
    return (
      <NewTaskRow
        date={prefill.startDate}
        schedules={prefill.isHabit ? [createDefaultSchedule(today)] : undefined}
        startTime={null}
        duration={null}
        goal={prefill.goalId}
        lifeArea={prefill.lifeAreaId}
        tags={prefill.tagIds}
      />
    );
  }

  if (type === TaskListItemTypes.Type) {
    return <TypeHeader item={itemInstance} denseFormat={denseFormat} />;
  }

  return null;
};
